// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemListTitle_container__24NaU","icon":"ItemListTitle_icon__ONuk9","info":"ItemListTitle_info__1hbLd","title":"ItemListTitle_title__1Twww"};